<template>
  <div class="container">
    <el-radio-group v-model="fxlx" size="mini" @change="submit">
      <el-radio-button v-for="(it, i) in type" :key="i" :label="fxlxObj[it]">{{
        it
      }}</el-radio-button>
      <!-- <el-radio-button :label="'day'">日</el-radio-button>
      <el-radio-button :label="'week'">周</el-radio-button>
      <el-radio-button :label="'month'">月</el-radio-button>
      <el-radio-button :label="'quarter'">季</el-radio-button>
      <el-radio-button :label="'year'">年</el-radio-button> -->
    </el-radio-group>
    <p style="width: 10px; height: 10px" />
    <template v-if="fxlx == 'hour' && type.indexOf('时') > -1">
      <el-date-picker
        :picker-options="{ firstDayOfWeek: 1 }"
        size="mini"
        v-model="sj[0]"
        type="datetime"
        placeholder="选择开始时间"
        format="yyyy/MM/dd HH:00"
        value-format="yyyy/MM/dd HH:mm:ss"
      />
      <p style="width: 10px; height: 10px" />
      <el-date-picker
        :picker-options="{ firstDayOfWeek: 1 }"
        size="mini"
        v-model="sj[1]"
        type="datetime"
        placeholder="选择结束时间"
        format="yyyy/MM/dd HH:00"
        value-format="yyyy/MM/dd HH:mm:ss"
      />
    </template>
    <template v-if="fxlx == 'day' && type.indexOf('日') > -1">
      <el-date-picker
        :picker-options="{ firstDayOfWeek: 1 }"
        size="mini"
        v-model="sj[0]"
        type="date"
        placeholder="选择日"
        format="yyyy/MM/dd"
        value-format="yyyy/MM/dd"
      />
      <p style="width: 10px; height: 10px" />
      <el-date-picker
        :picker-options="{ firstDayOfWeek: 1 }"
        size="mini"
        v-model="sj[1]"
        type="date"
        placeholder="选择日"
        format="yyyy/MM/dd"
        value-format="yyyy/MM/dd"
      />
    </template>
    <template v-if="fxlx == 'week' && type.indexOf('周') > -1">
      <el-date-picker
        :picker-options="{ firstDayOfWeek: 1 }"
        size="mini"
        v-model="sj[0]"
        type="week"
        placeholder="选择日"
        format="yyyy/MM/dd"
        value-format="yyyy/MM/dd"
      />
      <p style="width: 10px; height: 10px" />
      <el-date-picker
        :picker-options="{ firstDayOfWeek: 1 }"
        size="mini"
        v-model="sj[1]"
        type="week"
        placeholder="选择日"
        format="yyyy/MM/dd"
        value-format="yyyy/MM/dd"
      />
    </template>
    <template v-if="fxlx == 'month' && type.indexOf('月') > -1">
      <el-date-picker
        :picker-options="{ firstDayOfWeek: 1 }"
        size="mini"
        v-model="sj[0]"
        type="month"
        placeholder="选择月份"
        format="yyyy/MM"
        value-format="yyyy/MM/dd"
      />
      <p style="width: 10px; height: 10px" />
      <el-date-picker
        :picker-options="{ firstDayOfWeek: 1 }"
        size="mini"
        v-model="sj[1]"
        type="month"
        placeholder="选择月份"
        format="yyyy/MM"
        value-format="yyyy/MM/dd"
      />
    </template>
    <template v-if="fxlx == 'quarter' && type.indexOf('季') > -1">
      <weekSelect
        :className="'weekSelectInput1'"
        @func="startWeek"
        :date="sj[0]"
      />
      <p style="width: 10px; height: 10px" />
      <weekSelect
        :className="'weekSelectInput2'"
        @func="endWeek"
        :date="sj[1]"
      />
    </template>
    <template v-if="fxlx == 'year' && type.indexOf('年') > -1">
      <el-date-picker
        :picker-options="{ firstDayOfWeek: 1 }"
        size="mini"
        v-model="sj[0]"
        type="year"
        placeholder="选择年份"
        format="yyyy"
        value-format="yyyy/MM/dd"
      />
      <p style="width: 10px; height: 10px" />
      <el-date-picker
        :picker-options="{ firstDayOfWeek: 1 }"
        size="mini"
        v-model="sj[1]"
        type="year"
        placeholder="选择年份"
        format="yyyy"
        value-format="yyyy/MM/dd"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    type: {
      type: Array,
      default: () => {
        return ["01-03", "04-06", "07-09", "10-12"];
      },
    },
    sj: {
      type: Array,
      default: () => {
        return [new Date(), new Date()];
      },
    },
  },
  components: {},
  computed: {
    ...mapGetters([""]),
  },
  data() {
    return {
      fxlx: "hour",
      fxlxObj: {
        时: "hour",
        日: "day",
        周: "week",
        月: "month",
        季: "quarter",
        年: "year",
      },
    };
  },
  watch: {},
  mounted() {},
  methods: {
    submit() {
      this.$emit("");
    },
  },
  destroyed() {},
};
</script>
<style lang='stylus' scoped>
>>>.el-radio-group {
  display: flex;
}

.query_list .el-date-editor.el-input {
  width: 180px;
}

.el-date-editor >>>.el-input__inner {
  width: 180px !important;
  padding-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/timeDateSelect.vue